
import React from 'react';
import ReactDOM from 'react-dom';
import ImageBoard from '../ImageBoard';
import _ from 'lodash';

export default function TourImageBoard(props) {

    const { tour } = props.data
    const tour_images = !_.isEmpty(tour.images) ? JSON.parse(tour.images) : [];



    return (<ImageBoard images={tour_images} video={tour.video} />)
}



const container = document.getElementById('tour-image-board-w')
if (container) {
    const data = Object.assign({}, container.dataset);

    ReactDOM.render(<TourImageBoard data={JSON.parse(data.data)} />, container);
}



// WEBPACK FOOTER //
// ./resources/js/components/Shortcodes/TourImageBoard.jsx